import React, { FC, useEffect, useState } from "react";
import { Account } from "react-aad-msal";
import { State } from "../../store";
import { connect } from "react-redux";
import * as ActivityLogsStore from "../../store/ActivityLogsStore";
import * as GeneralStore from "../../store/GeneralStore";
import * as LineHandlingStore from "../../store/LineHandlingStore";
import * as TruckNominationStore from "../../store/TruckNominationStore";
import * as OfflineDataStore from "../../store/OfflineDataStore";
import * as ProcessFlowConfigStore from "../../store/ProcessFlowConfigStore";
import * as SofViewStore from "../../store/SofViewStore";
import * as WorkPacketStore from "../../store/WorkPacketStore";
import { useParams } from "react-router";
import NominationHandlingPane from "./nomination/NominationHandlingPane";
// import ActivitiesGrid from "./ActivitiesGrid";
import { SofView } from "../../models/SofView";
import ActivitiesPane from "./ActivitiesPane";

export type ISofProps = ActivityLogsStore.ActivityLogsState &
  GeneralStore.GeneralState &
  TruckNominationStore.TruckNominationState &
  OfflineDataStore.OfflineDataState &
  ProcessFlowConfigStore.ProcessFlowConfigState &
  SofViewStore.SofViewState &
  WorkPacketStore.WorkPacketState &
  LineHandlingStore.LineHandlingState &
  typeof ActivityLogsStore.actionCreators &
  typeof TruckNominationStore.actionCreators &
  typeof OfflineDataStore.actionCreators &
  typeof ProcessFlowConfigStore.actionCreators &
  typeof SofViewStore.actionCreators & {
    account: Account;
  } & typeof GeneralStore.actionCreators &
  typeof WorkPacketStore.actionCreators;
const TruckSofPage: FC<ISofProps> = (props: ISofProps) => {
  const { truckNomination, selectedState } = props;
  let param = useParams() as any;
  const nominationNo = param.lineHandlingNo;
  useEffect(() => {
    if (props.processFlowConfigs.result === undefined) {
      props.getAllConfigs(true);
    }
  }, []);

  useEffect(() => {
    // if (window.location.pathname.indexOf("truck") > 0) {
    //   props.setPageTitle("Truck Nomination");
    // } else if (window.location.pathname.indexOf("rail") > 0) {
    //   props.setPageTitle("Rail Nomination");
    // }
    props.setSofView(SofView.Nomination);
    props.getActivityLogsByNomination(nominationNo, () => {
      props.getTruckNomination(nominationNo, false, false);
    });
  }, []);

  useEffect(() => {
    if (
      truckNomination.result &&
      truckNomination.result.processFlowConfigId &&
      truckNomination.result.processFlowConfigVersion
    ) {
      props.setActiveConfig(
        truckNomination.result.processFlowConfigId,
        truckNomination.result.processFlowConfigVersion
      );
    }

    if (selectedState) {
      props.setSelectedState(selectedState);
    }
  }, [truckNomination]);

  return (
    <div style={{ height: "100%" }}>
      {nominationNo && (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
                      flexDirection: "column",
            justifyContent: "center"
          }}
        >
          <NominationHandlingPane {...props}>
            <div
              style={{
                width: "100%",
                background: "white",
                position: "relative",
              }}
            >
              <ActivitiesPane
                {...props}
                className="pane-card h-100"
                nominationNo={nominationNo}
                rejectionStatus={props.truckNomination.result?.rejectionStatus}
              />
              {/* <ActivitiesGrid {...props} /> */}
            </div>
          </NominationHandlingPane>
        </div>
      )}
      <div style={{ background: "#fff", height: "auto" }}></div>
    </div>
  );
};
export default connect(
  (state: State) => ({
    ...state.activityLogs,
    ...state.authentication,
    ...state.general,
    ...state.lineHandling,
    ...state.truckNomination,
    ...state.offlineData,
    ...state.processFlowConfigState,
    ...state.sofView,
    ...state.truckWorkPacket,
    ...state.workPacket,
  }),
  {
    ...ActivityLogsStore.actionCreators,
    ...TruckNominationStore.actionCreators,
    ...OfflineDataStore.actionCreators,
    ...ProcessFlowConfigStore.actionCreators,
    ...SofViewStore.actionCreators,
    ...GeneralStore.actionCreators,
    ...WorkPacketStore.actionCreators,
  }
)(TruckSofPage as any);
